export default __webpack_public_path__ + "8be62ead083f66bea47d28dc25675ed5.png";